import { ImageLoaderProps } from 'next/image';

import env from '@feed/tools/environments';

import { DEFAULT_LANG, SUPPORTED_LANGS } from '../constants/lang';
import type { BrazeSdk } from '../features/timeline/braze/braze-sdk';

export { SUPPORTED_LANGS, DEFAULT_LANG } from '../constants/lang';

declare global {
	interface Window {
		braze?: BrazeSdk;
	}
}

export const getAvatarUrl = (url?: string | null): string => {
	if (!url) {
		return '';
	}
	if (/^https?:\/\//i.test(url)) {
		return url;
	}
	const path = url.startsWith('/') ? url : `/${url}`;
	return `${env.PUBLIC_SITE_URL}${path}`;
};

export const imageLoader = ({ src, width, quality }: ImageLoaderProps) => {
	return `${process.env.NEXT_PUBLIC_API_BASE}${src}?w=${width}&q=${quality || 75}`;
};

export const waitForBraze = (): Promise<BrazeSdk | null> => {
	return new Promise((resolve) => {
		let index = 1;
		const interval = setInterval(() => {
			if (index > 10) {
				clearInterval(interval);
				resolve(null);
				return;
			}

			const { braze } = window;

			if (braze && braze.initialize()) {
				clearInterval(interval);
				resolve(braze);
			} else {
				index += 1;
			}
		}, 500);
	});
};

export const isMobileFeed = () => {
	if (typeof window === 'undefined') {
		return false;
	}
	const appUrl = `${process.env.NEXT_PUBLIC_API_BASE}/feed/app`;
	return window.location.href.includes(appUrl);
};

export const isEmbedded = () => {
	if (typeof window === 'undefined') {
		return false;
	}
	return (
		window.location != window.parent.location ||
		window.location.href.includes('feed/widget/embed')
	);
};

export const getQueryParam = (param: string): string | null => {
	if (typeof window === 'undefined') {
		return null;
	}
	const queryString = window.location.search;
	const params = new URLSearchParams(queryString);
	return params.get(param);
};

export const resolveLang = (
	langParam?: string | string[] | null,
	allowEmpty = false
) => {
	const queryParamLang = Array.isArray(langParam)
		? langParam[0] || ''
		: langParam || '';
	return allowEmpty
		? queryParamLang
		: SUPPORTED_LANGS.includes(
					queryParamLang as (typeof SUPPORTED_LANGS)[number]
			  )
			? queryParamLang
			: DEFAULT_LANG;
};

export const getLangQueryParam = (allowEmpty = false) =>
	resolveLang(getQueryParam('lang'), allowEmpty);
